// import * as React from "react"
// const ScaleSVG = (props) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     xmlSpace="preserve"
//     style={{
//       enableBackground: "new 0 0 122.88 122.76",
//     }}
//     // viewBox="0 0 122.88 122.76"
//     viewBox="-70 -75 250 250"
//     {...props}
//   >
//     <path d="M114.89 89.82c0-2.21 1.79-4 4-4s4 1.79 4 4v28.75c0 2.21-1.79 4-4 4H89.67c-2.21 0-4-1.79-4-4s1.79-4 4-4h19.18L74.49 82.09a3.994 3.994 0 0 1-.17-5.64 3.994 3.994 0 0 1 5.64-.17l34.93 33.02V89.82zM89.82 7.99c-2.21 0-4-1.79-4-4s1.79-4 4-4h28.75c2.21 0 4 1.79 4 4V33.2c0 2.21-1.79 4-4 4s-4-1.79-4-4V14.03L82.09 48.39a3.994 3.994 0 0 1-5.64.17 3.994 3.994 0 0 1-.17-5.64L109.3 7.99H89.82zM7.99 32.76c0 2.21-1.79 4-4 4s-4-1.79-4-4V4.01c0-2.21 1.79-4 4-4H33.2c2.21 0 4 1.79 4 4s-1.79 4-4 4H14.03l34.36 32.48c1.6 1.51 1.68 4.03.17 5.64a3.994 3.994 0 0 1-5.64.17L7.99 13.28v19.48zm24.95 82.01c2.21 0 4 1.79 4 4s-1.79 4-4 4H4.19c-2.21 0-4-1.79-4-4V89.55c0-2.21 1.79-4 4-4s4 1.79 4 4v19.18l32.48-34.36a3.994 3.994 0 0 1 5.64-.17c1.6 1.51 1.68 4.03.17 5.64l-33.02 34.93h19.48z" 
//         fill={'whitesmoke'} 
//     />
//     </svg>
// )
// export default ScaleSVG

// import * as React from "react"
// const ScaleSVG = (props) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     fillRule="evenodd"
//     clipRule="evenodd"
//     imageRendering="optimizeQuality"
//     shapeRendering="geometricPrecision"
//     textRendering="geometricPrecision"
//     // viewBox="0 0 512 512.002"
//     viewBox="-180 -225 860 860"
//     {...props}
//   >
//     <path 
//         d="m66.429 389.662-25.204-52.323C29.117 309.995.182 306.683 0 334.316v147.636c0 24.848 5.2 30.05 30.05 30.05h147.634c27.633-.184 24.321-29.119-3.023-41.227l-52.323-25.204 133.661-133.66 133.663 133.66-52.323 25.204c-27.344 12.106-30.658 41.043-3.025 41.225H481.95c24.849 0 30.05-5.202 30.05-30.05V334.316c-.182-27.633-29.119-24.321-41.224 3.023l-25.204 52.323-133.663-133.661L445.572 122.34l25.204 52.322c12.105 27.344 41.042 30.657 41.224 3.024V30.05C512 5.202 506.799 0 481.95 0H334.314c-27.633.184-24.319 29.119 3.025 41.226l52.323 25.204-133.661 133.661L122.338 66.428l52.323-25.203C202.005 29.119 205.317.182 177.684 0H30.05C5.2 0 0 5.202 0 30.05v147.634c.182 27.633 29.117 24.321 41.225-3.023l25.204-52.323 133.662 133.661L66.429 389.662z" 
//         fill={'whitesmoke'}
//     />
//   </svg>
// )
// export default ScaleSVG


import * as React from "react"
const ScaleSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 122.88 97.15",
    }}
    // viewBox="0 0 122.88 97.15"
    viewBox="-37 -50 190 190"
    {...props}
  >
    <path 
        d="M7.65 35.96H0V3.27C0 1.47 1.47 0 3.27 0h22.81v7.66H7.65v28.3zm31.36 61.19H3.27C1.46 97.15 0 95.68 0 93.86V56.51h39.01v40.64zM53.79 7.57V0h26.34v7.57H53.79zM99.67 0h19.94c1.81 0 3.27 1.47 3.27 3.27V36h-7.65V7.57H99.67V0zm23.21 57.07v36.8c0 1.81-1.47 3.27-3.27 3.27H99.67V89.5h15.58V57.07h7.63zM80.14 97.15H53.75V89.5h26.39v7.65z"
        fill={'whitesmoke'}
    />
  </svg>
)
export default ScaleSVG


